/**
 * Gọi `send`, hỏng thì chờ `delayMs` rồi gửi lại, tối đa `retries` lần nữa. Hết lượt vẫn hỏng thì bỏ qua, không ném lỗi
 * (lượt còn chờ sẽ được job đối soát xử lý).
 */
export const retryQuietly = (
  send: () => Promise<unknown>,
  retries = 2,
  delayMs = 2000
): Promise<void> =>
  send().then(
    () => undefined,
    () =>
      retries > 0
        ? new Promise<void>((resolve) => {
            setTimeout(resolve, delayMs);
          }).then(() => retryQuietly(send, retries - 1, delayMs))
        : undefined
  );
